import moment from 'moment'
import React, { FunctionComponent, useEffect, useRef, useState } from 'react'

import { getUserSettings } from '../settings/userSettings'

import { IProps } from './IProps'
import { Time, TimeLine, TimeLineWrapper, Timeslot } from './style'

export const TimeColumn: FunctionComponent<IProps> = ({
  calculatedPixelsPerHour,
  contrastColor,
}) => {
  const { zoomLevelValue } = getUserSettings()
  const zoomLevelValueCalc = parseInt(zoomLevelValue, 10) * 4

  const [currentTime, setCurrentTime] = useState(moment().format('HH:mm'))
  const lineRef = useRef<HTMLDivElement>(null)
  const timeSlots = []
  for (let i = 0; i < 24; i += 1) {
    timeSlots.push(
      <Timeslot
        zoomLevelValueCalc={zoomLevelValueCalc}
        colorContrast={contrastColor}
        key={`timeColumnSlot${i * 60}`}
      >
        {`${i}:00`}
      </Timeslot>,
    )
  }

  useEffect(() => {
    let timer: any
    const moveLine = () => {
      if (!lineRef.current) {
        timer = setTimeout(moveLine, 60 * 1000)
        return
      }
      const top = moment().diff(moment().startOf('hour'), 'seconds')
      lineRef.current.style.top = `${top}px`
      const currentHour = moment().format('HH')
      const currentMinutes = moment().format('mm')

      const calculatedMinute = calculatedPixelsPerHour / 60

      const hourCalculation =
        parseInt(currentHour, 10) * calculatedPixelsPerHour
      // NOTE 10 should be for the border in px
      const minuteCalculation =
        parseInt(currentMinutes, 10) * calculatedMinute - 10

      const combinedAndCalculatedCurrentTimeInPixels =
        hourCalculation + minuteCalculation

      lineRef.current.style.top = `${combinedAndCalculatedCurrentTimeInPixels}px`
      timer = setTimeout(moveLine, 60 * 1000)

      setCurrentTime(moment().format('HH:mm'))
    }
    moveLine()
    return () => {
      clearTimeout(timer)
    }
  }, [calculatedPixelsPerHour])

  return (
    <div>
      <TimeLineWrapper ref={lineRef}>
        <TimeLine />
        <Time>{currentTime}</Time>
      </TimeLineWrapper>

      {timeSlots}
    </div>
  )
}
